// extracted by mini-css-extract-plugin
module.exports = {"bundlerLoaderHeader":"BundlerLoaderProductInfo_bundlerLoaderHeader__z12KD"};